/**
 * Classe para formatar o field do tipo milhas ou quilometros.
 * @author: Adalto Junior
 * DATE: 20/08/2014
 */



Monet.Format = Monet.Format || {};
Monet.Format.MILES_OR_KM = (function () {

    function MILES_OR_KM(value) {

        Monet.Format.DISTANCE.apply(this, arguments);

        this.value = value;

        var appendAbbreviation = function (scope) {
            return function (key) {
                scope.value += ' ' + Monet.I18n.getResourcesByKey(key);
            };
        }(this);

        this.formatToKmOrMilesPerHour = function () {

            var keyPerHour = 'Greenmile.UnitMetrics.kilometersPerHour';

            if (Monet.Session.User.unitSystem === 'NON_METRIC') {
                keyPerHour = 'Greenmile.UnitMetrics.milesPerHour';
                this.convertKmToMiles();
            }

            this.format();
            appendAbbreviation(keyPerHour);

            return this;
        };

        this.toGrid = function () {

            var key = 'UnitSystems.Kilometers.abbreviation';

            if (typeof this.value === "number") {

                if (Monet.Session.User.unitSystem === 'NON_METRIC') {
                    this.convertKmToMiles();
                    key = 'UnitSystems.Miles.abbreviation';
                }

                this.format();
                appendAbbreviation(key);

            } else {
              this.value = '';
            }

            return this;

        };

    }

    return MILES_OR_KM;

}());
